import { render, staticRenderFns } from "./appStatusTag.vue?vue&type=template&id=162df9dd"
import script from "./appStatusTag.vue?vue&type=script&lang=js"
export * from "./appStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports